import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlPodcasts } from 'src/app/common';
import { Podcast } from 'src/app/models/obs/podcast';

@Injectable({
  providedIn: 'root'
})
export class PodcastsService {

  constructor(private http: HttpClient) { }

  getAll(){
    return this.http.get(`${urlPodcasts
    }/get-all`);
  }

  getAllForAdm(isnext: number) {
    return this.http.get(`${urlPodcasts}/get-all-4-adm/${isnext}`);
  }

  getImgCarousel() {
    return this.http.get(`${urlPodcasts}/get-all-4-carousel`);
  }

  getNextEpisodes() {
    return this.http.get(`${urlPodcasts}/get-next-episodes`);
  }

  getAllByGroup(id: string): Observable<Podcast[]> {
    return this.http.get<Podcast[]>(`${urlPodcasts}/getByIdGroup/${id}`);
  }
  
  getOne(id: string){
    return this.http.get(`${urlPodcasts}/get-one/${id}`);
  }
  
  create(data: Podcast): Observable<Podcast>{
    return this.http.post(`${urlPodcasts}/create`, data);
  }

  update(id: string, data: Podcast): Observable<Podcast>{
    return this.http.put(`${urlPodcasts}/update/${id}`, data);
  }

  delete(id: number){
    return this.http.delete(`${urlPodcasts}/delete/${id}`);
  }
}
